import {useRef} from 'react';
import {consoleLog} from '../../../core/utilities/Utilities.js';
import {useConfirm} from '../ConfirmContext.js';
import COMPONENT_MAP from '../Repository/Components.js';

const ManufacturingOrderPopup=({popupCallBack,rowId,parent,userData,application,fromPopup=false})=>{
    const pageDetailRef=useRef();
    const {confirm}=useConfirm();

    const callOnPageDetail=async(callName,args)=>{
        if(pageDetailRef.current&&pageDetailRef.current[callName]){
            return await pageDetailRef.current[callName](args);
        }
    };

    // mark_produced/cancel_mo must be resolved against THIS record via the PageDetail ref's own
    // invokeMethod (same as ManufacturingOrderDetail.js's standalone page) - forwarding the
    // 'invokeMethod' action up to popupCallBack instead would hit ListTab.js's popupCallBack,
    // whose "invokeMethod" case is for the "pick a row to invoke a method on the PARENT record"
    // pattern (e.g. StorageOrderDetailItems' add_sku) - it closes this popup immediately and
    // calls a pageCallback the batch's MO list doesn't even provide, so the action would never
    // actually reach the backend.
    const handleInvokeMethod=async(method)=>{
        consoleLog({file:'ManufacturingOrderPopup.js',context:'handleInvokeMethod',arg_name:'method',arg_value:method});
        switch(method.name){
            case "cancel_mo":
                const template_cancel_mo=application.getLocale("ConfirmMessageCancelManufacturingOrder");
                const message_cancel_mo=template_cancel_mo.replace("#{MO_NUMBER}", method?.args?.recordFields?.single_fields?.reference?.value);
                if(await confirm({message:message_cancel_mo})){
                    await callOnPageDetail('invokeMethod',method);
                    popupCallBack('refreshParent',{close:false});
                }
                break;

            case "mark_produced":
                await callOnPageDetail('invokeMethod',{name:'mark_produced',args:{}});
                popupCallBack('refreshParent',{close:false});
                break;

            default:
                break;
        }
    }

    const pageCallback=async(action,args)=>{
        if(action==='invokeMethod'){
            handleInvokeMethod(args);
        }
        else{
            popupCallBack(action,args);
        }
    }

    const renderPageDetail=()=>{
        const Component=COMPONENT_MAP['PageDetail'];
        return Component?(
            <Component
                recordId={rowId}
                userData={userData}
                application={application}
                entityType={'ManufacturingOrder'}
                entityParams={[
                    '_context='+[
                        'parent_field_name='+parent.parent_field_name,
                        'parent_field_value='+parent.parent_field_value,
                        'parent_name='+parent.parent_name,
                    ].join(","),
                    '_lang=' + application.globalData.lang,
                ]}
                file={'ManufacturingOrderPopup.js'}
                titleLabel={rowId?application.getLocale("ManufacturingOrderTitle"):application.getLocale("PageTabNewManufacturingOrder")}
                pageCallback={pageCallback}
                pageTabs={[]}
                isPopUp={true}
                fromPopup={fromPopup}
                ref={pageDetailRef}
            />
        ):null;
    };
    return (renderPageDetail());
}

export default ManufacturingOrderPopup;
